var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOptimizer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "142px",
    height: "139px",
    viewBox: "0 0 142 139",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Optimizer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.Universes---Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Optimizer",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.770923,50.6165625 L120.369971,50.6165625 C119.559204,48.2063379 118.57334,45.8567578 117.41936,43.5852246 L125.46875,35.6821875 C125.469287,35.6816602 125.469824,35.6811328 125.470361,35.6806055 C127.707153,33.4834277 127.706616,29.9220117 125.46875,27.725625 L109.260937,11.8125 C106.994067,9.6880957 103.426855,9.6880957 101.159985,11.8125 L93.0990479,19.7213379 C90.7857178,18.5886035 88.3923584,17.6204004 85.9375,16.824375 L85.9375,5.62491211 C85.9375,2.51833008 83.3725342,0 80.2084229,0 L57.2918457,0 C54.1274658,0 51.5625,2.51833008 51.5625,5.62491211 L51.5625,16.824375 C49.1049561,17.6180273 46.7086426,18.5843848 44.3923584,19.7155371 L36.3429688,11.8125 C34.0760986,9.68493164 30.5059326,9.68493164 28.2390625,11.8125 L12.03125,27.725625 C9.79472656,29.9222754 9.79472656,33.4829004 12.03125,35.6792871 L20.0865479,43.5936621 C18.9328369,45.8649316 17.9467041,48.2147754 17.1359375,50.625 L5.72907715,50.625 C2.56496582,50.625 0,53.1433301 0,56.2499121 L0,67.5 L5.72907715,67.5 L5.72907715,56.2499121 L19.2470459,56.2499121 C20.5237549,56.2501758 21.6463135,55.4209277 22,54.2164746 C22.9936523,50.8085156 24.3713379,47.52 26.1078125,44.4120996 C26.7257568,43.3149609 26.5294434,41.948877 25.6265625,41.0624121 L16.0845459,31.7023242 L32.2894043,15.7920996 L41.8341064,25.160625 C42.7364502,26.0457715 44.1262207,26.238252 45.2428711,25.633125 C48.4059082,23.9292773 51.7523682,22.5766406 55.2202148,21.6 C56.4469727,21.2527441 57.2915771,20.1505957 57.2913086,18.8970996 L57.2913086,5.62491211 L80.2078857,5.62491211 L80.2078857,18.8970996 C80.2076172,20.1505957 81.0522217,21.2527441 82.2789795,21.6 C85.7508545,22.5758496 89.1010742,23.9284863 92.2678711,25.633125 C93.3845215,26.238252 94.774292,26.0457715 95.6766357,25.160625 L105.210059,15.7920996 L121.414917,31.7023242 L111.8729,41.0708496 C110.97002,41.9573145 110.773706,43.3233984 111.39165,44.4205371 C113.127588,47.5258008 114.505273,50.811416 115.499463,54.2164746 C115.853149,55.4209277 116.975708,56.2501758 118.252417,56.2499121 L131.770386,56.2499121 L131.770386,67.5 L137.5,67.5 L137.5,56.2414746 C137.5,53.1348926 134.935034,50.6165625 131.770923,50.6165625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3334661,36.6666667 C52.6854729,36.6666667 40,49.2162194 40,64.6971369 L40,67.5 L45.666587,67.5 L45.666587,64.6968741 C45.6668526,52.3123503 55.8150716,42.2726556 68.3334661,42.2726556 C80.8518607,42.2726556 91.0000797,52.3123503 91.0000797,64.6968741 L91.0000797,67.5 L96.6666667,67.5 L96.6666667,64.6968741 C96.6666667,49.2162194 83.9814593,36.6666667 68.3334661,36.6666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 67.5,
    y: 14.1666667,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 31.6666667,
    y: 29.1666667,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 15.8333333,
    y: 64.1666667,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 120.833333,
    y: 64.1666667,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 105,
    y: 29.1666667,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6429289,108.333333 L7.85707111,108.333333 C4.89841495,108.333333 2.5,110.9452 2.5,114.166831 L2.5,131.666776 C2.5,134.888407 4.89841495,137.5 7.85707111,137.5 L34.6429289,137.5 C37.601585,137.5 40,134.888407 40,131.666776 L40,114.166831 C40,110.9452 37.601585,108.333333 34.6429289,108.333333 Z M34.6429289,131.666776 L7.85707111,131.666776 L7.85707111,114.166831 L34.6429289,114.166831 L34.6429289,131.666776 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.642929,108.333333 L107.857071,108.333333 C104.898415,108.333333 102.5,110.944951 102.5,114.166612 L102.5,131.666721 C102.5,134.888382 104.898415,137.5 107.857071,137.5 L134.642929,137.5 C137.601585,137.5 140,134.888382 140,131.666721 L140,114.166612 C140,110.945225 137.601585,108.333333 134.642929,108.333333 Z M134.642929,131.666995 L107.857071,131.666995 L107.857071,114.166885 L134.642929,114.166885 L134.642929,131.666995 L134.642929,131.666995 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8093444,108.333333 L57.0237378,108.333333 C54.0650816,108.333333 51.6666667,110.944951 51.6666667,114.166612 L51.6666667,131.666721 C51.6666667,134.888382 54.0650816,137.5 57.0237378,137.5 L83.8095956,137.5 C86.7682517,137.5 89.1666667,134.888382 89.1666667,131.666721 L89.1666667,114.166612 C89.1666667,110.945225 86.7680006,108.333333 83.8093444,108.333333 Z M83.8095956,131.666995 L83.8095956,131.666995 L57.0237378,131.666995 L57.0237378,114.166885 L83.8095956,114.166885 L83.8095956,131.666995 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.939724,85.8333333 L19.5602756,85.8333333 C17.9622396,85.8333333 16.6666667,87.0770833 16.6666667,88.6111979 L16.6666667,102.5 L22.4536133,102.5 L22.4536133,91.3888021 L115.046115,91.3888021 L115.046115,102.5 L120.833333,102.5 L120.833333,88.6111979 C120.833333,87.0770833 119.53776,85.8333333 117.939724,85.8333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 66.6666667,
    y: 67.5,
    width: 5,
    height: 35.8333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 15.8333333,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 24.1666667,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 62.5,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 75,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 110.833333,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 120.833333,
    y: 118.333333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75,51.6666667 C60.6958481,51.6666667 54.1666667,57.8848958 54.1666667,65.5554688 L54.1666667,68.3333333 L59.9999453,68.3333333 L59.9999453,65.5554688 C59.9999453,60.953125 63.9175089,57.2221354 68.75,57.2221354 C73.5824911,57.2221354 77.5000547,60.953125 77.5000547,65.5554688 L77.5000547,68.3333333 L83.3333333,68.3333333 L83.3333333,65.5554688 C83.3333333,57.8848958 76.8041519,51.6666667 68.75,51.6666667 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOptimizer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Optimizer.5750543e.svg";
export { ForwardRef as ReactComponent };